import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { 
  TextField,
 
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  CircularProgress,
  FormControl,
  
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography
} from '@mui/material';
import MyButton from '../../../utils/MyButton';
import { postCronogramaMtoAuto, getServiciosEquipos,getListaMtosClienteFiltrado } from '../../../redux/actions/dataactions';
import { getTecnicos} from '../../../redux/actions/useractions';
import { clearErrors } from '../../../redux/actions/dataactions';
import { FaArrowLeft, FaPlus, FaFirstAid, FaCheck, FaCheckCircle } from "react-icons/fa";
import './CronogramaMtoAuto.css';

export class CronogramaMtoAuto extends Component {
    constructor() {
    super();
    this.state = {
      servicio: '',
      idprestador: '',
      fecha: '',
      frecuencia: 'riesgo', 
      responsable: '',
      actividades:'Verificación General, Limpieza General, Verificación de Funcionamiento, Actividades Recomendadas por el Fabricante, Reemplazo de componentes desgastados',
      errors:{},
      aprobado:{},
      open: false
    };
  };

    static getDerivedStateFromProps(props, state) {
    const newState = {};

    if (props.UI.errors) {
      newState.errors = props.UI.errors;
    }

    if (props.UI.aprobado) {
      newState.aprobado = props.UI.aprobado;
    }

    return Object.keys(newState).length > 0 ? newState : null;
  }

 

     componentDidMount() {
        // Cargar servicios cuando el componente se monta
        if (this.props.clienteId) {
            this.props.getServiciosEquipos(this.props.clienteId);
        }
    }

    handleOpen = () => {
        this.setState({ open: true,errors:{},aprobado:{}});
        this.props.getTecnicos(this.props.handleuser);
        // Recargar servicios cada vez que se abre el diálogo
        if (this.props.clienteId) {
            this.props.getServiciosEquipos(this.props.clienteId);
        }
    };
 handleClose = () => {
   const { credentials } = this.props.user;
  const { clienteId } = this.props;

  let responsable = "Todos";
  if (credentials.tipouser === "Tecnico") {
    responsable = credentials.handle;
  }

  if (this.state.aprobado.mensaje) {
     this.setState({
      servicio: '',
      idprestador: '',
      fecha: '',
      frecuencia: 'riesgo',
      open: false,
      errors: {},
      aprobado:{}
    });
      this.props.getListaMtosClienteFiltrado(
        clienteId,
        "01/01/1950",
        "01/01/2035",
        responsable
      );
    } else {
      this.setState({
      servicio: '',
      idprestador: '',
      fecha: '',
      frecuencia: 'riesgo',
      open: false,
      errors: {},
      aprobado:{}
    });
    }
  };
        handleChange=(event)=>{
            this.setState({[event.target.name]:event.target.value});
            };


    handleSubmit=(event)=>{
      const { credentials } = this.props.user;
      let responsable = "Todos"; // por defecto para técnicos

      if (credentials.tipouser === "Tecnico") {
        responsable = credentials.handle;
      }
      
            event.preventDefault();
            let fechamto=new Date(this.state.fecha);
            let day;
            let mes;
            let newfecha;
            let year;
            let mesnombre;
    
            if(fechamto.getDate()>=30){
              day=1;
              
              mes=fechamto.getMonth()+1;
              if(mes>11){
                mes=0;
                year=fechamto.getFullYear()+1;
              }else{
                year=fechamto.getFullYear();
              }
              newfecha=fechamto.setDate(day);
              newfecha=fechamto.setMonth(mes);
              newfecha=new Date(newfecha);
              mes=mes+1;
              mesnombre=newfecha.toLocaleString('es-Es', {
                month: 'long',
              });
            }else{
              day=fechamto.getDate()+1;
              mes=fechamto.getMonth()+1;
              year=fechamto.getFullYear();
              mesnombre=fechamto.toLocaleString('es-Es', {
                month: 'long',
              });
            }
            
         
            const newUserData = {
              servicio: this.state.servicio,
              fecha: this.state.fecha,
              idprestador: this.props.clienteId,
              responsable: this.state.responsable,
              actividades:this.state.actividades,
              dia: day,
              mes: mes, 
              year: year,
              mesnombre: mesnombre,
              frecuencia: this.state.frecuencia
            };

          console.log(newUserData)
      this.props.postCronogramaMtoAuto(newUserData,this.props.clienteId,responsable);
           
           
         
     }

   render() {
    const { UI: { loading }, data: { servicios, loadingdata } } = this.props;
    const { errors, frecuencia } = this.state;
    
    return (
      <Fragment>
        <div className='div-card-link' onClick={this.handleOpen}>
          <div className="dashing-cardcontent">
            <div className="dashing-cardtext">
              <p className="dashing-text-card">
                Generar Cronograma Automático
              </p>
            </div>
            <div className="dashing-cardicon">
              <FaFirstAid color="#FFFFFF" className="dashing-icon" />
            </div>
          </div>
        </div>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
 {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Programación Generada Exitosamente</h2>
              </div>
                
                ):(<div>
 <DialogTitle >
           <Typography sx={{ 
                                                      fontSize: '20px', 
                                                      fontWeight: 600, 
                                                      color: '#0468BF', 
                                                      textAlign: 'center' 
                                                  }}>
                                                      Generar Cronograma Automático
                            </Typography>
           
          </DialogTitle>

          <DialogContent>
            <Box component="form" onSubmit={this.handleSubmit}>
              <FormControl fullWidth margin="normal">
               <Typography sx={{
                               color: '#0468BF',
                               fontSize: '18px',
                               fontWeight: 400,
                               ml: 1,
                             }}>
                              Servicio a Programar
                             </Typography>
                {loadingdata ? (
                  <CircularProgress size={24} />
                ) : (
                  <TextField
                    select
                    name="servicio"
                    id="servicio"
                    label="Seleccione un servicio"
                    value={this.state.servicio}
                    onChange={this.handleChange}
                    fullWidth
                    helperText={errors.servicio}
                    error={Boolean(errors.servicio)}
                    variant="outlined"
                  >
                    <MenuItem value="Todos">Todos los servicios</MenuItem>
                    {servicios && servicios.map((servicio, index) => (
                      <MenuItem key={index} value={servicio}>
                        {servicio}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </FormControl>

              <FormControl component="fieldset" fullWidth margin="normal">
  <Typography 
    variant="subtitle1"
    sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      mb: 2,
    }}
  >
    Frecuencia de Mantenimiento
  </Typography>
  
  <RadioGroup
    name="frecuencia"
    value={frecuencia}
    onChange={this.handleChange}
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(3, 1fr)' },
      gap: 1,
    }}
  >
    <FormControlLabel 
      value="riesgo" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Según riesgo</Typography>
      }
      sx={{
        margin: 0,
        '& .MuiFormControlLabel-label': { fontSize: '14px' }
      }}
    />
    <FormControlLabel 
      value="bimestral" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Bimestral</Typography>
      }
      sx={{ margin: 0 }}
    />
    <FormControlLabel 
      value="trimestral" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Trimestral</Typography>
      }
      sx={{ margin: 0 }}
    />
    <FormControlLabel 
      value="semestral" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Semestral</Typography>
      }
      sx={{ margin: 0 }}
    />
    <FormControlLabel 
      value="anual" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Anual</Typography>
      }
      sx={{ margin: 0 }}
    />
    <FormControlLabel 
      value="fechasel" 
      control={<Radio size="small" />} 
      label={
        <Typography variant="body2">Fecha Seleccionada</Typography>
      }
      sx={{ margin: 0 }}
    />
  </RadioGroup>
</FormControl>

              <FormControl fullWidth margin="normal">
              <Typography sx={{
                               color: '#0468BF',
                               fontSize: '18px',
                               fontWeight: 400,
                               ml: 1,
                               mb:1
                             }}>
                              Fecha de Inicio
                             </Typography>
                <TextField
                  type="date"
                  name="fecha"
                  id="fecha"
                  label="Fecha de inicio"
                  value={this.state.fecha}
                  onChange={this.handleChange}
                  fullWidth
                  helperText={errors.fecha}
                  error={Boolean(errors.fecha)}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    min: "2020-01-01", 
                    max: "2030-12-31"
                  }}
                />
              </FormControl>

              <FormControl fullWidth margin="normal">
              <Typography sx={{
                               color: '#0468BF',
                               fontSize: '18px',
                               fontWeight: 400,
                               ml: 1,
                               mb:1
                             }}>
                              Actividades
                             </Typography>
                <TextField
                    multiline
                    minRows={3}
                    name="actividades"
                    id="actividades"
                    label="Actividades del mantenimiento"
                    value={this.state.actividades}
                    onChange={this.handleChange}
                    fullWidth
                    variant="outlined"
                    inputProps={{ maxLength: 200 }}
                    error={Boolean(this.state.errors?.actividades)}
                    helperText={this.state.errors?.actividades || ''}
                  />
                
                  {/* Contador alineado a la derecha */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                      {(this.state.actividades?.length || 0)}/200
                    </Typography>
                  </Box>
              </FormControl>

              <FormControl fullWidth margin="normal">
                <Typography sx={{
                  color: '#0468BF',
                  fontSize: '18px',
                  fontWeight: 400,
                  ml: 1,
                  mb: 1
                }}>
                  Responsable
                </Typography>
                <TextField
                  select
                  name="responsable"
                  id="responsable"
                  label="Seleccione un responsable"
                  value={this.state.responsable}
                  onChange={this.handleChange}
                  fullWidth
                  helperText={errors.responsable}
                  error={Boolean(errors.responsable)}
                  variant="outlined"
                >
                  <MenuItem value="Todos">Todos</MenuItem>
                  {this.props.tecnicos && this.props.tecnicos.map((handle, index) => (
                    <MenuItem key={index} value={handle}>
                      {handle}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Box>
          </DialogContent>

                </div>)}

         <DialogActions>
                     <MyButton tip="Cerrar" onClick={this.handleClose}>
                     <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
                      </MyButton>
                      {loading ? (
                         <CircularProgress size={30} color="primary" className="login-progress" />
                       ) : (
                         this.state.aprobado.mensaje ? (
                           <MyButton tip="Continuar" onClick={this.handleClose}>
                             <FaCheckCircle color="#0cae1aff" className="icon-formulario" />
                           </MyButton>
                         ) : (
                           <MyButton tip="Generar Cronograma" onClick={this.handleSubmit}>
                             <FaPlus color="#03178C" className="icon-formulario" />
                           </MyButton>
                         )
                       )}
                     
                    </DialogActions>
        
        </Dialog>
      </Fragment>
    )
  }
}

CronogramaMtoAuto.propTypes = {
    postCronogramaMtoAuto: PropTypes.func.isRequired,
    getListaMtosClienteFiltrado:PropTypes.func.isRequired,
    getTecnicos: PropTypes.func.isRequired,
    getServiciosEquipos:PropTypes.func.isRequired,
    clienteId: PropTypes.string.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired  
  };

const mapActionsToProps={postCronogramaMtoAuto,getServiciosEquipos,getListaMtosClienteFiltrado,getTecnicos,clearErrors};

const mapStateToProps = (state)=>({
    user:state.user,
    data:state.data,
    UI:state.UI,
    handleuser: state.user.credentials.handle,
    tecnicos: state.user.tecnicos,
})



export default connect(mapStateToProps,mapActionsToProps)(CronogramaMtoAuto);
